import * as React from 'react'

export const LockIconDark = () => (
  <svg
    width='15'
    height='18'
    viewBox='0 0 15 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.75 6H11.875V4.28571C11.875 1.92 9.915 0 7.5 0C5.085 0 3.125 1.92 3.125 4.28571V6H2.25C1.2875 6 0.5 6.77143 0.5 7.71429V16.2857C0.5 17.2286 1.2875 18 2.25 18H12.75C13.7125 18 14.5 17.2286 14.5 16.2857V7.71429C14.5 6.77143 13.7125 6 12.75 6ZM7.5 13.7143C6.5375 13.7143 5.75 12.9429 5.75 12C5.75 11.0571 6.5375 10.2857 7.5 10.2857C8.4625 10.2857 9.25 11.0571 9.25 12C9.25 12.9429 8.4625 13.7143 7.5 13.7143ZM10.2125 6H4.7875V4.28571C4.7875 2.82 6.00375 1.62857 7.5 1.62857C8.99625 1.62857 10.2125 2.82 10.2125 4.28571V6Z'
      fill='black'
      fillOpacity='0.4'
    />
  </svg>
)
